import { render, staticRenderFns } from "./PDFTranslate.vue?vue&type=template&id=32fbf6a8&scoped=true&"
import script from "./PDFTranslate.vue?vue&type=script&lang=js&"
export * from "./PDFTranslate.vue?vue&type=script&lang=js&"
import style0 from "./PDFTranslate.vue?vue&type=style&index=0&id=32fbf6a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fbf6a8",
  null
  
)

export default component.exports